<template>
  <div class="container text-center" style="height:74vh;">
    <h1>Contact Us</h1>
    <p>Feel free to reach out with any questions you may have:<br>
      <ContactUsIconLink hyperlink-text="Contact Us">
      </ContactUsIconLink>
    </p>
  </div>
</template>

<script>
import ContactUsIconLink from "../layout/ContactUsIconLink.vue";

export default {
  name: 'ContactShow',
  components: {
    ContactUsIconLink,
  },
}
</script>

<style scoped lang="scss">

</style>
